import React, { useState } from 'react';

import AddCategoryModal from 'components/shared/modals/AddCategoryModal';
import AddItemModal from 'components/shared/modals/AddItemModal';
import AddTypeModal from 'components/shared/modals/AddTypeModal';
import EditCategoryModal from 'components/shared/modals/EditCategoryModal';
import EditItemModal from 'components/shared/modals/EditItemModal';
import EditTypeModal from 'components/shared/modals/EditTypeModal';

import Category from 'schema/category';
import Item from 'schema/item';
import Type from 'schema/type';

interface ModalContextProviderProps {
  children?: React.ReactNode;
}

const ModalContext = React.createContext<{
  openAddItemModal: null | (() => void);
  openEditItemModal: null | ((item: Item) => void);
  openAddCategoryModal: null | (() => void);
  openEditCategoryModal: null | ((category: Category) => void);
  openAddTypeModal: null | ((category: Category) => void);
  openEditTypeModal: null | ((type: Type) => void);
}>({
  openAddItemModal: null,
  openEditItemModal: null,
  openAddCategoryModal: null,
  openEditCategoryModal: null,
  openAddTypeModal: null,
  openEditTypeModal: null,
});

const ModalContextProvider: React.FC<ModalContextProviderProps> = ({
  children,
}) => {
  const [isAddItemModalOpen, setisAddItemModalOpen] = useState(false);

  const [isEditItemModalOpen, setIsEditItemModalOpen] = useState(false);
  const [editItemModalItem, setEditItemModalItem] = useState<Item | null>(null);

  const [isAddCategoryModalOpen, setIsAddCategoryModalOpen] = useState(false);

  const [isEditCategoryModalOpen, setIsEditCategoryModalOpen] = useState(false);
  const [editCategoryModalCategory, setEditCategoryModalCategory] =
    useState<Category | null>(null);

  const [isAddTypeModalOpen, setIsAddTypeModalOpen] = useState(false);
  const [addTypeModalCategory, setAddTypeModalCategory] =
    useState<Category | null>(null);

  const [isEditTypeModalOpen, setIsEditTypeModalOpen] = useState(false);
  const [editTypeModalType, setEditTypeModalType] = useState<Type | null>(null);

  const openAddItemModal = () => {
    setisAddItemModalOpen(true);
  };

  const openEditItemModal = (item: Item) => {
    setEditItemModalItem(item);
    setIsEditItemModalOpen(true);
  };

  const openAddCategoryModal = () => {
    setIsAddCategoryModalOpen(true);
  };

  const openEditCategoryModal = (category: Category) => {
    setEditCategoryModalCategory(category);
    setIsEditCategoryModalOpen(true);
  };

  const openAddTypeModal = (category: Category) => {
    setAddTypeModalCategory(category);
    setIsAddTypeModalOpen(true);
  };

  const openEditTypeModal = (type: Type) => {
    setEditTypeModalType(type);
    setIsEditTypeModalOpen(true);
  };

  return (
    <ModalContext.Provider
      value={{
        openAddItemModal,
        openEditItemModal,
        openAddCategoryModal,
        openEditCategoryModal,
        openAddTypeModal,
        openEditTypeModal,
      }}
    >
      <AddItemModal
        isOpen={isAddItemModalOpen}
        setIsOpen={setisAddItemModalOpen}
      />
      <EditItemModal
        isOpen={isEditItemModalOpen}
        setIsOpen={setIsEditItemModalOpen}
        item={editItemModalItem}
        resetItem={() => {
          setEditItemModalItem(null);
        }}
      />
      <AddCategoryModal
        isOpen={isAddCategoryModalOpen}
        setIsOpen={setIsAddCategoryModalOpen}
      />
      <EditCategoryModal
        isOpen={isEditCategoryModalOpen}
        setIsOpen={setIsEditCategoryModalOpen}
        category={editCategoryModalCategory}
        resetCategory={() => {
          setEditCategoryModalCategory(null);
        }}
      />
      <AddTypeModal
        isOpen={isAddTypeModalOpen}
        setIsOpen={setIsAddTypeModalOpen}
        category={addTypeModalCategory}
        resetCategory={() => {
          setAddTypeModalCategory(null);
        }}
      />
      <EditTypeModal
        isOpen={isEditTypeModalOpen}
        setIsOpen={setIsEditTypeModalOpen}
        type={editTypeModalType}
        resetType={() => {
          setEditTypeModalType(null);
        }}
      />
      {children}
    </ModalContext.Provider>
  );
};

export default ModalContextProvider;
export { ModalContext };
